// Styles SCSS
import './sass/home.scss';

import LazyLoad from 'vanilla-lazyload';
import ScrollReveal from 'scrollreveal';
import { tns } from 'tiny-slider/src/tiny-slider';

// SVG polyfiil
// import 'svgxuse';

// Vanilla
document.addEventListener('DOMContentLoaded', function () {
	ScrollReveal().reveal('.presentation');
	ScrollReveal().reveal('.home__title');
	ScrollReveal().reveal('.bandeau');
	ScrollReveal().reveal('.services__item',{ interval:100 });
	ScrollReveal().reveal('.chambres__images',{ delay:650 });
	ScrollReveal().reveal('.chambres__info',{ delay:400 });
	jQuery('.menu-burger').on('click', function() {
		jQuery('.responsive-menu').slideToggle();
	});
	new LazyLoad({
		elements_selector: '.lazy',
	});

	var slider = tns({
		container: '.slider',
		items: 4,
		loop: true,
		autoplayButtonOutput: false,
		nav: false,
		mouseDrag: true,
		controls: true,
		autoplay: true,
		controlsText: [
			'<i class="fal fa-chevron-left"></i>',
			'<i class="fal fa-chevron-right"></i>',
		],
		responsive: {
			'350': {
				'items': 2
			},
			'500': {
				'items': 3
			}
		},
	});
});
